import { useState } from "react";
import { Outlet } from "react-router-dom";
import FactorySidebar from "./FactorySidebar";
import FactoryTopbar from "./FactoryTopbar";
import { useAuth } from "@/App";
import { useNotificationSocket } from "@/hooks/useNotificationSocket";

const FactoryLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user } = useAuth();
  useNotificationSocket(user);

  return (
    <div className="flex min-h-screen bg-[#0F1A1A]" data-testid="factory-layout">
      <FactorySidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <div className="flex-1 flex flex-col min-h-screen overflow-hidden">
        <FactoryTopbar onMenuToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default FactoryLayout;
